import { DefaultError } from 'src/app/shared/constants/errors.constants';

export const getErrorKey = (errorResponse, defaultErrorKey = DefaultError): string => {
  // errorCode should be localization LocalizationItemParams.ContentId to apply localization
  const errorKeyFromBE = errorResponse?.error?.code;

  return errorKeyFromBE || defaultErrorKey;
};

/**
 * Extracts human-readable reasons from an RFC7231 validation error response, e.g.
 * `{ errors: { TimeFrom: ["A space should be booked not less than 30 minutes..."] } }`.
 * These are ready-to-display messages (not localization keys). Falls back to `title`
 * then `message`. Returns [] when nothing usable is present.
 */
export const getValidationErrorMessages = (errorResponse): string[] => {
  const errors = errorResponse?.error?.errors;
  if (errors && typeof errors === 'object') {
    const messages = Object.values(errors)
      .flat()
      .filter((message): message is string => typeof message === 'string');
    if (messages.length) {
      return messages;
    }
  }

  const fallback = errorResponse?.error?.title || errorResponse?.error?.message;
  return fallback ? [fallback] : [];
};
